import {observer} from "mobx-react-lite";
import React, {useEffect, useState} from "react";
import {useStore} from "../../helpers";
import {toJS} from "mobx";
import moment from "moment";
import { Pagination } from "@mui/material";
import { LoadingState } from "../../components/LoadingState";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../helpers/utils";
import { PRINT_MEDIA_PAGE_SIZE } from "./print-media-settings";

export const ArticlesView = observer((props: any) => {

    const rootStore = useStore();
    const {mediaStore} = rootStore;
    const [activeArticle, setActiveArticle] = useState(null)
    const {printMediaFilters} = mediaStore
    const {from_date, to_date, lang, sources, offset} = printMediaFilters
    const [loading, setLoading] = useState(false)
    const appMode = rootStore.appMode;

    useEffect(() => {
        fetchArticles()
    }, [from_date, to_date, lang, sources, offset, mediaStore.currentPage, mediaStore.printMediaReport]);


    const fetchArticles = async () => {
        setLoading(true)
        await mediaStore.getArticles();
        if (mediaStore.articles && mediaStore.articles['articles'] && mediaStore.articles['articles'].length > 0) setActiveArticle(mediaStore.articles['articles'][0]);
        setLoading(false)
    }


    const articleLeftSideTitles = () =>
        toJS(mediaStore.articles["articles"]).map((article) => {
            const isArticleActive = activeArticle?.id === article.id;
            return (
                <div
                    key={article.id}
                    className={classNames(
                        isArticleActive ? "rounded-md border-1 border-gray-100 bg-purple-100 shadow-md" : "bg-transparent",
                        "flex cursor-pointer flex-row p-1 hover:bg-gray-300"
                    )}
                    style={{ height: 32 }}
                    onClick={() => setActiveArticle(article)}
                >
                    <div className="truncate pl-2 text-gray-800">{article.title}</div>
                </div>
            );
        });

    const renderActiveArticle = () => (
        <div>
            <div className="flex flex-row justify-between md:pb-2 lg:pb-4">
                <div className="rounded-full bg-green-500 px-4 py-1 text-sm font-bold text-white">{activeArticle.source}</div>
                <div className="rounded-full bg-green-500 px-4 py-1 text-sm font-bold text-white">
                    Date: {moment(activeArticle.date).format("DD MMM YYYY")}
                </div>
            </div>
            <div className="pb-2 text-2xl font-bold">{activeArticle.title}</div>
            <div className="custom" dangerouslySetInnerHTML={{ __html: activeArticle.content }} />
        </div>
    );

    const placeHolder = () => {
        return (
            <div className='text-lg italic text-gray-500 px-8 py-8'>Please select the article from left side</div>
        )
    }

    if (activeArticle === null) return null;
    if (mediaStore.articles === null) return null;
    if (toJS(mediaStore.articles.length) === 0) return null;


    if (!mediaStore.articles) return null;
    if (!mediaStore.articles['articles']) return null;
    if (mediaStore.articles['articles'].length === 0) return (
        <>
            <div className='italic'>No articles matching filters found</div>
        </>
    );
    const articles = toJS(mediaStore.articles);
    const total = articles['total'];
    const a_offset = articles['offset'];
    const count = articles['articles'].length;

    //Accordion view in app
    const articlesAppView = () => {
        return (
            <div className="bg-gray-50">
                <div className="max-w-7xl mx-auto">
                    <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
                        <dl className="space-y-6 divide-y divide-gray-200">
                            {articles['articles'].map((article) => (
                                <Disclosure as="div" key={article.id} className="pt-2">
                                    {({open}) => (
                                        <>
                                            <dt className="text-md">
                                                <Disclosure.Button
                                                    className="text-left w-full flex justify-between items-start text-gray-400">
                                                    <span className="font-medium font-bold text-gray-900">{article.title}</span>
                                                    <span className="ml-6 h-7 flex items-center">
                                                      <ChevronDownIcon
                                                          className={classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}
                                                          aria-hidden="true"
                                                      />
                                                    </span>
                                                </Disclosure.Button>
                                            </dt>
                                            <Disclosure.Panel as="dd" className="mt-2 pr-12">
                                                <div className='flex flex-row justify-between pb-2'>
                                                    <div className='bg-green-500  text-white font-bold text-sm rounded-full px-2 py-1'>{article['source']}</div>
                                                    <div className='bg-green-500  text-white font-bold text-sm rounded-full px-2 py-1'>Date:
                                                        {moment(article['date']).format("DD MMM YYYY")}</div>
                                                </div>
                                                <div className='custom' dangerouslySetInnerHTML={{__html: article.content}}></div>
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                            ))}
                        </dl>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className='bg-white shadow-md p-4 rounded-lg'>
                {loading ? <LoadingState/> : null }
                <div className='flex flex-row justify-between items-center flex-wrap'>
                    <div className='font-bold text-2xl'>Articles</div>
                    <Pagination
                        className="flex justify-center py-2 text-xl font-bold lg:py-4"
                        count={Math.ceil(mediaStore.articles["total"] / PRINT_MEDIA_PAGE_SIZE)}
                        shape="rounded"
                        siblingCount={3}
                        size="large"
                        color="primary"
                        onChange={(_e, val) => {
                            mediaStore.setCurrentPage(val);
                        }}
                    />
                    <div className='italic'>Showing {a_offset + 1} to {a_offset + count} of {total} results
                    </div>
                </div>
                {!appMode ?
                    <>
                        <div className="flex flex-row flex-nowrap w-full overflow-auto"
                             style={{maxHeight: '760px'}}>
                            <div
                                className={classNames(
                                    'text-gray-400 group-hover:text-gray-500',
                                    '-w-full md:w-1/3 lg:w-5/12 overflow-auto bg-white border border-gray-400 p-4 m-2'
                                )}>
                                {articleLeftSideTitles()}
                            </div>
                            <div
                                className="w-full md:w-2/3 lg:w-7/12 bg-white border overflow-auto border-gray-400 m-2 p-4">
                                {activeArticle ? renderActiveArticle() : placeHolder()}
                            </div>
                        </div>
                    </> : articlesAppView()
                }
            </div>
        </>
    );
});